var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button",on:{"click":_vm.onClick}},[_c('a-icon',{staticStyle:{"font-size":"18px"},attrs:{"type":"shrink"}}),_c('div',[_vm._v("缩小地图")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }